import React, {forwardRef, useMemo} from "react";
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, Title, Tooltip} from "chart.js";
import {Bar} from 'react-chartjs-2';


ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const BarChart = forwardRef(({
                                 formatDataLabel,
                                 onHover: onHoverProp,
                                 onClick: onClickProp,
                                 displayLegend = true,
                                 scales,
                                 createToolTipValue,
                                 tooltipCallbacks,
                                 ...props
                             }, ref) => {
    /**@type {import("chart.js").ChartOptions<"line">}*/
    const options = useMemo(() => ({
            responsive: true,
            maintainAspectRatio: false,
            ...(!!onHoverProp ? {onHover: onHoverProp} : {}),
            ...(!!onClickProp ? {onClick: onClickProp} : {}),
            plugins: {
                tooltip: {
                    displayColors: false,
                    titleFont: () => ({
                        size: 14,
                    }),
                    bodyFont: () => ({
                        size: 12,
                    }),
                    padding: () => 10,
                    callbacks: {
                        label: (tooltipItem) => {
                            const data = tooltipItem.dataset.data[tooltipItem.label];
                            return (
                                `${
                                    tooltipItem.dataset.label ?? ''
                                }: ${
                                    tooltipItem.dataset.formatValue
                                        ? tooltipItem.dataset.formatValue(data)
                                        : createToolTipValue?.(data, tooltipItem) ?? tooltipItem.formattedValue
                                }`
                            )
                        },
                        ...(tooltipCallbacks ?? {}),
                    },
                },
                legend: {
                    position: 'top',
                    display: displayLegend,
                },
            },
            ...(!!scales ? scales : {})
        }),
        [createToolTipValue, displayLegend, onClickProp, onHoverProp, scales, tooltipCallbacks]
    )

    return (
        <Bar
            {...props}
            ref={ref}
            options={options}
        />
    );
})

export default BarChart;
